"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AlarmOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlarmOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5V5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 0-1h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 0a3.5 3.5 0 0 1 3.216 2.117 7.04 7.04 0 0 1 2.568 0 3.5 3.5 0 1 1 5.208 4.261C14.82 7.188 15 8.073 15 9a6.985 6.985 0 0 1-2.463 5.33l.817.816a.5.5 0 0 1-.708.708l-.924-.925A6.967 6.967 0 0 1 8 16a6.967 6.967 0 0 1-3.722-1.07l-.924.924a.5.5 0 0 1-.708-.708l.817-.816A6.985 6.985 0 0 1 1 9c0-.927.18-1.812.508-2.622A3.5 3.5 0 0 1 3.5 0Zm2.495 3.343A5.957 5.957 0 0 1 8 3a6.04 6.04 0 0 1 2.005.343 6.019 6.019 0 0 1 3.589 3.483C13.856 7.5 14 8.233 14 9a5.987 5.987 0 0 1-3.006 5.2c-.881.51-1.904.8-2.994.8a5.972 5.972 0 0 1-3.828-1.38A5.988 5.988 0 0 1 2 9a5.985 5.985 0 0 1 .853-3.085 6.019 6.019 0 0 1 3.142-2.572ZM1.956 5.466a7.021 7.021 0 0 1 3.777-3.09 2.5 2.5 0 1 0-3.777 3.09ZM15 3.5c0 .798-.374 1.509-.956 1.966a7.021 7.021 0 0 0-3.777-3.09A2.5 2.5 0 0 1 15 3.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlarmOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AlarmOff;
exports["default"] = _default;